import ReactQuill, { Quill } from "react-quill";
import styled from "styled-components";
import { Scrollable } from "../../../../../common/styles";

const bold = Quill.import("formats/bold");

// Override the tagName property to 'b'
bold.tagName = "b";

// Register the modified bold format with React Quill
Quill.register("formats/bold", bold);

export const SendAnnouncementContainer = styled.div`
  width: 100%;
  max-height: 60vh;
  ${Scrollable};
`;

export const StyledReactQuill = styled(ReactQuill)`
  /* Custom styles for the ReactQuill editor */
  .ql-editor {
    background-color: #f8f8f8; /* Change background color */
    color: #333; /* Change text color */
    font-family: sans-serif; /* Change font family */
    font-size: 14px; /* Change font size */
    line-height: 1.5; /* Change line height */
    min-height: 80px;
  }

  .ql-snow .ql-tooltip {
    margin-left: 5px !important;
    left: 1px !important;
  }
  .ql-editor:not(.ql-blank)::before,
  .ql-editor.ql-blank::before,
  .ql-editor::placeholder {
    font-style: normal !important;
  }
`;
export const InputFileUploadContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px;
`;

export const LabelButton = styled.label`
  display: flex;
  align-items: center;
  padding: 10px 15px;
  border: 1px solidrgba(68, 68, 155, 0.14);
  border-radius: 3px;
  background: rgba(68, 68, 155, 0.1);
  font-size: 14px;
  cursor: pointer;
  transition: background 0.3s;
  color: #44449b;
  width: 137px;
  height: 43px;
  box-sizing: border-box;
  svg {
    margin-right: 10px;
  }
  &:hover {
    background: rgb(68 68 155 / 20%);
  }
`;
export const FileText = styled.div`
  font-size: 14px;
  overflow: auto;
  color: #333;
  padding: 12px 8px;
  max-width: 260px;
  width: 100%;
  border-radius: 5px;
  border: 1px solid #ececf5;
  background: #f8f8f8;
`;
